// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","535":"login","571":"settings"}[chunkId] + "." + {"177":"79d1a2b7","535":"593bb8f9","571":"57faffbf"}[chunkId] + ".css";
};